"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = require("../style");
var _style2 = require("./style");
var _ButtonItem = _interopRequireDefault(require("../ButtonItem/ButtonItem"));
var _Tooltip = _interopRequireDefault(require("../../Tooltip/Tooltip"));
var _keyCode = require("../keyCode");
var _TooltipLabel = _interopRequireDefault(require("../TooltipLabel/TooltipLabel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const OptionalWrapper = _ref => {
  let {
    condition,
    wrapper,
    children
  } = _ref;
  return condition ? wrapper(children) : children;
};
class PopupMenu extends _react.default.Component {
  constructor(props) {
    super(props);
    this.closePopup = () => {
      if (this.props.closePopup) {
        this.props.closePopup();
      }
      this.setState({
        focusedItem: -1
      });
    };
    this.isPopupOpen = () => this.props.isOpen;
    this.hasSubItems = item => item.subItems && item.subItems.length > 0;
    this.isFirstItem = index => index === this.firstItem;
    this.isLastItem = index => index === this.lastItem;
    this.setFocusToItem = index => {
      this.setState({
        focusedItem: index
      });
    };
    this.setFocusToNextItem = () => {
      const {
        focusedItem
      } = this.state;
      const newIndex = this.isLastItem(focusedItem) ? this.firstItem : focusedItem + 1;
      this.setFocusToItem(newIndex);
    };
    this.setFocusToPreviousItem = () => {
      const {
        focusedItem
      } = this.state;
      const newIndex = this.isFirstItem(focusedItem) ? this.lastItem : focusedItem - 1;
      this.setFocusToItem(newIndex);
    };
    this.handleKeydown = event => {
      let flag = false;
      switch (event.keyCode) {
        case this.keyCode.DOWN:
          if (this.isPopupOpen()) {
            this.setFocusToNextItem();
          }
          flag = true;
          break;
        case this.keyCode.UP:
          if (this.isPopupOpen()) {
            this.setFocusToPreviousItem();
          }
          flag = true;
          break;
        case this.keyCode.ESC:
        case this.keyCode.TAB:
          this.closePopup();
          break;
        default:
          break;
      }
      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    };
    this.focusPopupToItem = index => {
      this.popup.focus();
      this.setFocusToItem(index);
    };
    this.renderItems = items => {
      const {
        focusedItem
      } = this.state;
      return items.map((item, index) => {
        const hasSubItems = this.hasSubItems(item);
        const shouldFocus = index === focusedItem && !this.props.usingMouse;
        const type = index === 0 ? 'header' : '';
        const {
          defaultTooltipMessage
        } = item;
        return [item.hasDivider && ( /*#__PURE__*/_react.default.createElement(_style2.ItemDivider, {
          key: `${item.id}--divider`,
          role: "none",
          type: type
        }, item.dividerTitle && ( /*#__PURE__*/_react.default.createElement(_style.ItemDividerTitle, null, item.dividerTitle)))), /*#__PURE__*/_react.default.createElement(OptionalWrapper, {
          key: `item-wrapper-${index}`,
          condition: hasSubItems || defaultTooltipMessage,
          wrapper: children => {
            const tooltip = /*#__PURE__*/_react.default.createElement(_TooltipLabel.default, {
              maxItems: 5,
              items: item.subItems,
              defaultMessage: defaultTooltipMessage
            });
            return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
              customLabel: tooltip,
              position: "left",
              verticalAlign: "top"
            }, children);
          }
        }, /*#__PURE__*/_react.default.createElement(_style.Item, {
          key: `item-${index}`,
          role: "none",
          type: item.type
        }, /*#__PURE__*/_react.default.createElement(_ButtonItem.default, {
          index: index,
          item: item,
          shouldFocus: shouldFocus,
          ariaHaspopup: false
        })))];
      });
    };
    this.state = {
      focusedItem: -1,
      tabIndex: '-1'
    };
    this.firstItem = props.items.length > 0 ? 0 : -1;
    this.lastItem = props.items.length - 1 || -1;
    this.keyCode = _keyCode.keyCode;
    this.handleKeydown = this.handleKeydown.bind(this);
  }
  componentDidMount() {
    this.popup.addEventListener('keydown', this.handleKeydown);
  }
  componentDidUpdate(prevProps) {
    this.updateIfNeeded(prevProps);
  }
  componentWillUnmount() {
    this.popup.removeEventListener('keydown', this.handleKeydown);
  }
  updateIfNeeded(prevProps) {
    const {
      isOpen,
      usingMouse,
      onOpen,
      onOpenChange
    } = this.props;
    let newTabIndex = '-1';
    if (prevProps.isOpen !== isOpen) {
      if (isOpen) {
        if (usingMouse) newTabIndex = '0';
        this.focusPopupToItem(0);
        if (onOpen) {
          onOpen();
        }
      } else {
        this.setFocusToItem(-1);
      }
      if (onOpenChange) {
        onOpenChange();
      }
      this.setState({
        tabIndex: newTabIndex
      });
    }
  }
  render() {
    const {
      ariaLabelPopup,
      horizontalOffset,
      items,
      isOpen,
      onBlur,
      xPosition,
      size
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_style2.PopupMenuStyled, {
      ref: popup => this.popup = popup,
      role: "menu",
      "aria-label": ariaLabelPopup,
      isOpen: isOpen,
      xPosition: xPosition,
      horizontalOffset: horizontalOffset,
      onBlur: onBlur,
      tabIndex: this.state.tabIndex,
      onKeyDown: ev => this.handleKeydown(ev),
      size: size
    }, this.renderItems(items));
  }
}
exports.default = PopupMenu;
PopupMenu.propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  horizontalOffset: _propTypes.default.string,
  xPosition: _propTypes.default.string,
  onBlur: _propTypes.default.func.isRequired,
  closePopup: _propTypes.default.func.isRequired,
  ariaLabelPopup: _propTypes.default.string,
  usingMouse: _propTypes.default.bool,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    title: _propTypes.default.string,
    colors: _propTypes.default.shape({
      title: _propTypes.default.string,
      iconHover: _propTypes.default.string
    })
  })).isRequired,
  onOpen: _propTypes.default.func,
  onOpenChange: _propTypes.default.func,
  size: _propTypes.default.oneOf(['md', 'lg'])
};
PopupMenu.defaultProps = {
  ariaLabelPopup: null,
  horizontalOffset: null,
  xPosition: 'left',
  usingMouse: false,
  onOpen: null,
  onOpenChange: null,
  size: 'md'
};